<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-end dropdown-no-arrow" ngbDropdownToggle [title]="'Toggle Actions Dropdown'|translate">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button ngbDropdownItem [disabled]="!isSuperAdminRole" (click)="onEditMachineCategory(machineCategory)">
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit</span>
    </button>
    <button ngbDropdownItem class="text-danger" [disabled]="!isSuperAdminRole" (click)="onDeleteMachineCategory(machineCategory)">
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete</span>
    </button>
  </div>
</div>
